// // src/components/MCPTool.tsx
// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   Button,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment,
//   Stack,
//   IconButton,
//   Divider,
//   LinearProgress,
//   CircularProgress,
//   Switch,
//   FormControlLabel,
//   Paper,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import LaunchIcon from "@mui/icons-material/Launch";
// import CloseIcon from "@mui/icons-material/Close";
// import PublicIcon from "@mui/icons-material/Public";
// import BusinessIcon from "@mui/icons-material/Business";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE } from "../services/api";

// interface MCPFunctionSummary {
//   func_key: string;
//   display_name: string;
//   description: string;
//   method: string;
//   tags: string[];
// }

// interface ModuleItem {
//   module_key: string;
//   description: string;
//   endpoint_prefix: string;
//   tags: any;
//   endpoint_count?: number;
//   functions?: MCPFunctionSummary[];
//   auto_approve?: boolean;
//   org_id: string; // ✅ 그룹핑을 위해 필수
// }

// interface MyAccessItem {
//   module_key: string;
//   status: "requested" | "approved";
//   requested_at?: string;
//   approved_at?: string | null;
// }

// interface Props {
//   setErrorMsg: (msg: string | null) => void;
// }

// export default function MCPTool({ setErrorMsg }: Props) {
//   const navigate = useNavigate();

//   const [modules, setModules] = useState<ModuleItem[]>([]);
//   const [loadingModules, setLoadingModules] = useState<boolean>(false);

//   // 내 접근 상태 로딩
//   const [loadingAccess, setLoadingAccess] = useState<boolean>(false);
//   const [requestedSet, setRequestedSet] = useState<Set<string>>(new Set());
//   const [approvedSet, setApprovedSet] = useState<Set<string>>(new Set());

//   // 새 모듈 추가 다이얼로그
//   const [open, setOpen] = useState(false);
//   const [query, setQuery] = useState("");

//   // form state
//   const [moduleKey, setModuleKey] = useState("");
//   const [moduleKeyError, setModuleKeyError] = useState<string | null>(null);
//   const endpointPreview = moduleKey.trim() ? `/mcp/${moduleKey.trim()}` : "/mcp/<module_key>";
//   const [description, setDescription] = useState("");
//   const [tags, setTags] = useState<string[]>([]);
//   const [tagInput, setTagInput] = useState("");
//   const [tagError, setTagError] = useState<string | null>(null);
//   const [autoApprove, setAutoApprove] = useState<boolean>(false);
//   const [creating, setCreating] = useState<boolean>(false);

//   const authHeaders = useMemo(
//     () => ({
//       "x-user-id": localStorage.getItem("user_id") || "",
//       "x-access-token": localStorage.getItem("access_token") || "",
//       "x-refresh-token": localStorage.getItem("refresh_token") || "",
//     }),
//     []
//   );

//   // Tier 체크
//   const userTier = useMemo(() => {
//     const t = localStorage.getItem("user_tier");
//     return t ? parseInt(t, 10) : 2; 
//   }, []);

//   // Builder(2)는 MCP 추가 불가
//   const canCreateMCP = userTier <= 1;

//   const normalizeTags = (t: any): string[] => {
//     if (!t && t !== 0) return [];
//     if (Array.isArray(t)) return t.map(String);
//     if (typeof t === "string") {
//       try {
//         const parsed = JSON.parse(t);
//         if (Array.isArray(parsed)) return parsed.map(String);
//       } catch {
//         const parts = t.split(",").map((s) => s.trim()).filter(Boolean);
//         return parts;
//       }
//       return t ? [t] : [];
//     }
//     return [String(t)];
//   };

//   const fetchModules = () => {
//     setLoadingModules(true);
//     axios
//       .get(`${API_BASE}mcp-list`, { headers: authHeaders })
//       .then((res) => {
//         const body = res.data;
//         if (body.success) {
//           const rows: ModuleItem[] = body.data.modules || [];
//           setModules(
//             rows.map((m) => ({
//               ...m,
//               tags: normalizeTags(m.tags),
//               auto_approve: typeof m.auto_approve === "boolean" ? m.auto_approve : false,
//             }))
//           );
//           setErrorMsg(null);
//         } else {
//           setErrorMsg(body.message || body.error || "MCP 목록 조회 실패");
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//         setErrorMsg("MCP 목록을 불러오는 중 오류가 발생했습니다.");
//       })
//       .finally(() => setLoadingModules(false));
//   };

//   const fetchMyAccessStatus = async () => {
//     setLoadingAccess(true);
//     try {
//       const [reqRes, apprRes] = await Promise.all([
//         axios.get(`${API_BASE}mcp/me/access`, {
//           headers: authHeaders,
//           params: { status: "requested" },
//         }),
//         axios.get(`${API_BASE}mcp/me/access`, {
//           headers: authHeaders,
//           params: { status: "approved" },
//         }),
//       ]);

//       if (reqRes.data?.success) {
//         const list: MyAccessItem[] = reqRes.data.data || [];
//         setRequestedSet(new Set(list.map((x) => x.module_key)));
//       } else {
//         setRequestedSet(new Set());
//       }

//       if (apprRes.data?.success) {
//         const list: MyAccessItem[] = apprRes.data.data || [];
//         setApprovedSet(new Set(list.map((x) => x.module_key)));
//       } else {
//         setApprovedSet(new Set());
//       }
//     } catch (e) {
//       console.warn("Failed to load my access status");
//       setRequestedSet(new Set());
//       setApprovedSet(new Set());
//     } finally {
//       setLoadingAccess(false);
//     }
//   };

//   useEffect(() => {
//     fetchModules();
//     fetchMyAccessStatus();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ✅ 검색 필터링
//   const filteredModules = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return modules;
//     return modules.filter((m) => {
//       const tagText = normalizeTags(m.tags).join(" ");
//       const hay = `${m.module_key} ${m.description} ${m.endpoint_prefix} ${tagText}`.toLowerCase();
//       return hay.includes(q);
//     });
//   }, [modules, query]);

//   // ✅ 그룹핑 로직 (전체 공용 / 조직 공용)
//   const groupedModules = useMemo(() => {
//     const global: ModuleItem[] = [];
//     const org: ModuleItem[] = [];
    
//     filteredModules.forEach(mod => {
//       if (mod.org_id === '#GLOBAL#') {
//         global.push(mod);
//       } else {
//         org.push(mod);
//       }
//     });

//     return { global, org };
//   }, [filteredModules]);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => {
//     setModuleKey("");
//     setModuleKeyError(null);
//     setDescription("");
//     setTags([]);
//     setTagInput("");
//     setTagError(null);
//     setAutoApprove(false);
//     setCreating(false);
//     setOpen(false);
//   };

//   const addTag = (raw: string) => {
//     setTagError(null);
//     const val = raw.trim();
//     if (!val) return;
//     if (tags.length >= 10) {
//       setTagError("최대 10개까지 가능합니다.");
//       return;
//     }
//     const normalized = val.replace(/\s+/g, "-");
//     if (tags.includes(normalized)) {
//       setTagError("중복 태그입니다.");
//       return;
//     }
//     setTags((prev) => [...prev, normalized]);
//   };

//   const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
//       e.preventDefault();
//       if (tagInput.trim()) {
//         addTag(tagInput);
//         setTagInput("");
//       }
//     }
//   };

//   const removeTag = (idx: number) => {
//     setTags((prev) => prev.filter((_, i) => i !== idx));
//   };

//   const handleAddModule = () => {
//     setModuleKeyError(null);
//     const mk = moduleKey.trim();
//     if (!mk) return setModuleKeyError("모듈 키를 입력하세요.");
    
//     const exists = modules.some((m) => (m.module_key || "").toLowerCase() === mk.toLowerCase());
//     if (exists) return setModuleKeyError(`모듈키 '${mk}'는 이미 존재합니다.`);

//     const payload = {
//       module_key: mk,
//       description: description || "",
//       tags: tags,
//       auto_approve: autoApprove,
//     };

//     setCreating(true);
//     axios
//       .post(`${API_BASE}mcp-modules`, payload, { headers: authHeaders })
//       .then((res) => {
//         if (res.data.success) {
//           fetchModules();
//           handleClose();
//         } else {
//           setErrorMsg(res.data.message || "모듈 추가 실패");
//         }
//       })
//       .catch((err) => {
//         setErrorMsg("모듈 추가 중 오류 발생");
//       })
//       .finally(() => setCreating(false));
//   };

//   const openModule = (module_key: string) => navigate(`/mcp/${module_key}`);

//   const LoadingBanner = (props: { text: string }) => (
//     <Paper variant="outlined" sx={{ mb: 2 }}>
//       <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
//         <CircularProgress size={20} />
//         <Typography>{props.text}</Typography>
//       </Box>
//       <LinearProgress />
//     </Paper>
//   );

//   const AccessStatusChip = ({ mk }: { mk: string }) => {
//     if (approvedSet.has(mk)) {
//       return <Chip size="small" color="success" label="승인됨" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
//     }
//     if (requestedSet.has(mk)) {
//       return <Chip size="small" color="warning" label="요청중" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
//     }
//     return <Chip size="small" variant="outlined" label="미설치" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
//   };

//   const anyLoading = loadingModules || loadingAccess;

//   // ✅ 카드 렌더링 헬퍼 컴포넌트
//   const ModuleCard = ({ mod }: { mod: ModuleItem }) => {
//     const tagList = normalizeTags(mod.tags);
//     const hasFunctionsCount = typeof mod.endpoint_count === "number";

//     return (
//       <Card
//         sx={{
//           bgcolor: "#1e1e1e",
//           height: "100%",
//           display: "flex",
//           flexDirection: "column",
//           position: "relative",
//           cursor: "pointer",
//           transition: "all 0.2s",
//           "&:hover": { 
//             transform: "translateY(-4px)",
//             boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
//             outline: "1px solid rgba(255,255,255,0.2)" 
//           },
//         }}
//         onClick={() => openModule(mod.module_key)}
//       >
//         <IconButton
//           size="small"
//           sx={{ position: "absolute", top: 8, right: 8, color: "grey.500" }}
//           onClick={(e) => { e.stopPropagation(); openModule(mod.module_key); }}
//         >
//           <LaunchIcon fontSize="small" />
//         </IconButton>

//         <CardContent sx={{ flexGrow: 1, p: 3 }}>
//           <Box mb={2}>
//             <Stack direction="row" alignItems="center" spacing={1} mb={1}>
//               <Typography variant="h6" color="#fff" fontWeight={700}>
//                 {mod.module_key}
//               </Typography>
//               <AccessStatusChip mk={mod.module_key} />
//             </Stack>
            
//             <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
//               {mod.auto_approve && (
//                 <Chip size="small" label="자동승인" color="primary" variant="outlined" sx={{ height: 20, fontSize: "0.7rem" }} />
//               )}
//               {Array.isArray(mod.functions) && (
//                 <Chip size="small" label={`${mod.functions.length} funcs`} sx={{ height: 20, fontSize: "0.7rem", bgcolor: "#333" }} />
//               )}
//               {hasFunctionsCount && !Array.isArray(mod.functions) && (
//                 <Chip size="small" label={`${mod.endpoint_count} funcs`} sx={{ height: 20, fontSize: "0.7rem", bgcolor: "#333" }} />
//               )}
//             </Stack>
//           </Box>

//           <Typography variant="body2" color="grey.400" sx={{ mb: 2, minHeight: 40, lineHeight: 1.5 }}>
//             {mod.description || "설명이 없습니다."}
//           </Typography>

//           <Divider sx={{ my: 1.5, borderColor: "#333" }} />

//           <Box sx={{ minHeight: 24 }}>
//             {tagList.length > 0 ? (
//               <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
//                 {tagList.slice(0, 5).map((t, i) => (
//                   <Chip 
//                     key={i} 
//                     size="small" 
//                     label={`#${t}`} 
//                     sx={{ bgcolor: "rgba(255,255,255,0.05)", color: "#aaa", fontSize: "0.7rem", height: 22 }} 
//                   />
//                 ))}
//                 {tagList.length > 5 && (
//                   <Typography variant="caption" color="grey.600" sx={{ pt: 0.5 }}>+{tagList.length - 5}</Typography>
//                 )}
//               </Stack>
//             ) : (
//               <Typography variant="caption" color="grey.700">No Tags</Typography>
//             )}
//           </Box>
//         </CardContent>
//       </Card>
//     );
//   };

//   return (
//     <Box>
//       {/* 상단 로딩 */}
//       {anyLoading && <LoadingBanner text="데이터를 불러오는 중..." />}

//       {/* 헤더 + 검색 + 추가 버튼 */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//         <Box>
//           <Typography variant="h6" fontWeight="bold">MCP Tool</Typography>
//           <Typography variant="body2" color="text.secondary">
//             AI Agent가 활용할 수 있는 다양한 도구(Tool)들을 탐색하고 설치하세요.
//           </Typography>
//         </Box>

//         <Box display="flex" alignItems="center" gap={1}>
//           <TextField
//             size="small"
//             placeholder="검색 (키워드, 태그)"
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             InputProps={{
//               startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>),
//             }}
//             sx={{ width: 250 }}
//           />
//           {canCreateMCP && (
//             <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpen}>
//               추가
//             </Button>
//           )}
//         </Box>
//       </Box>

//       {/* ✅ 섹션 1: 전체 공용 (#GLOBAL#) */}
//       {groupedModules.global.length > 0 && (
//         <Box mb={4}>
//           <Stack direction="row" alignItems="center" spacing={1} mb={2}>
//             <PublicIcon color="secondary" />
//             <Typography variant="h6" fontWeight="bold" color="#ce93d8">
//               전체 공용 (Global Tools)
//             </Typography>
//           </Stack>
//           <Grid container spacing={3}>
//             {groupedModules.global.map((mod) => (
//               <Grid item xs={12} sm={6} md={4} lg={3} key={mod.module_key}>
//                 <ModuleCard mod={mod} />
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       )}

//       {/* ✅ 섹션 2: 조직 공용 (Org Specific) */}
//       {groupedModules.org.length > 0 && (
//         <Box mb={4}>
//           <Stack direction="row" alignItems="center" spacing={1} mb={2}>
//             <BusinessIcon color="primary" />
//             <Typography variant="h6" fontWeight="bold" color="#90caf9">
//               {groupedModules.org[0].org_id} 조직 공용
//             </Typography>
//           </Stack>
//           <Grid container spacing={3}>
//             {groupedModules.org.map((mod) => (
//               <Grid item xs={12} sm={6} md={4} lg={3} key={mod.module_key}>
//                 <ModuleCard mod={mod} />
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       )}

//       {/* 결과 없음 표시 */}
//       {!loadingModules && filteredModules.length === 0 && (
//         <Box sx={{ color: "#666", textAlign: "center", py: 8 }}>
//           검색 결과가 없습니다.
//         </Box>
//       )}

//       {/* 다이얼로그 (생성용) */}
//       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "#fff" } }}>
//         <DialogTitle sx={{ borderBottom: "1px solid #333" }}>새 MCP 도구 추가</DialogTitle>
//         <DialogContent sx={{ mt: 2 }}>
//           <TextField
//             autoFocus
//             label="모듈 키 (ID)"
//             value={moduleKey}
//             onChange={(e) => { setModuleKey(e.target.value); setModuleKeyError(null); }}
//             fullWidth
//             margin="normal"
//             placeholder="예) weather-tool"
//             helperText={moduleKeyError}
//             error={!!moduleKeyError}
//             InputLabelProps={{ style: { color: "#aaa" } }}
//             InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//           />
//           <TextField
//             label="설명"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             fullWidth
//             multiline
//             rows={2}
//             margin="normal"
//             InputLabelProps={{ style: { color: "#aaa" } }}
//             InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//           />
//           <FormControlLabel
//             control={<Switch checked={autoApprove} onChange={(e) => setAutoApprove(e.target.checked)} />}
//             label={<Typography color="#ccc">자동 승인</Typography>}
//             sx={{ mt: 1 }}
//           />
//           <Divider sx={{ my: 2, borderColor: "#333" }} />
//           <Typography variant="caption" color="grey.500" sx={{ mb: 1, display: "block" }}>
//             태그 (Enter로 추가)
//           </Typography>
//           <TextField
//             size="small"
//             value={tagInput}
//             onChange={(e) => setTagInput(e.target.value)}
//             onKeyDown={handleTagKeyDown}
//             fullWidth
//             InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//           />
//           <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
//             {tags.map((t, i) => (
//               <Chip key={i} label={t} onDelete={() => removeTag(i)} size="small" sx={{ bgcolor: "#333", color: "#fff" }} />
//             ))}
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, borderTop: "1px solid #333" }}>
//           <Button onClick={handleClose} sx={{ color: "#aaa" }}>취소</Button>
//           <Button variant="contained" onClick={handleAddModule} disabled={!moduleKey.trim() || creating}>
//             {creating ? "추가 중..." : "추가"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Stack,
  IconButton,
  Divider,
  LinearProgress,
  CircularProgress,
  Switch,
  FormControlLabel,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import LaunchIcon from "@mui/icons-material/Launch";
import CloseIcon from "@mui/icons-material/Close";
import PublicIcon from "@mui/icons-material/Public";
import BusinessIcon from "@mui/icons-material/Business";
import FaceIcon from "@mui/icons-material/Face"; // ✅ 팀 아이콘 추가
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../services/api";

interface MCPFunctionSummary {
  func_key: string;
  display_name: string;
  description: string;
  method: string;
  tags: string[];
}

interface ModuleItem {
  module_key: string;
  description: string;
  endpoint_prefix: string;
  tags: any;
  endpoint_count?: number;
  functions?: MCPFunctionSummary[];
  auto_approve?: boolean;
  org_id: string; 
  user_id?: string;   // ✅ 추가: 작성자 ID (예: asset)
  user_tier?: number; // ✅ 추가: 작성자 등급 (0: 조직관리자, 1: 팀/개인)
}

interface MyAccessItem {
  module_key: string;
  status: "requested" | "approved";
  requested_at?: string;
  approved_at?: string | null;
}

interface Props {
  setErrorMsg: (msg: string | null) => void;
}

export default function MCPTool({ setErrorMsg }: Props) {
  const navigate = useNavigate();

  const [modules, setModules] = useState<ModuleItem[]>([]);
  const [loadingModules, setLoadingModules] = useState<boolean>(false);

  // 내 접근 상태 로딩
  const [loadingAccess, setLoadingAccess] = useState<boolean>(false);
  const [requestedSet, setRequestedSet] = useState<Set<string>>(new Set());
  const [approvedSet, setApprovedSet] = useState<Set<string>>(new Set());

  // 새 모듈 추가 다이얼로그
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  // form state
  const [moduleKey, setModuleKey] = useState("");
  const [moduleKeyError, setModuleKeyError] = useState<string | null>(null);
  const endpointPreview = moduleKey.trim() ? `/mcp/${moduleKey.trim()}` : "/mcp/<module_key>";
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState("");
  const [tagError, setTagError] = useState<string | null>(null);
  const [autoApprove, setAutoApprove] = useState<boolean>(false);
  const [creating, setCreating] = useState<boolean>(false);

  const authHeaders = useMemo(
    () => ({
      "x-user-id": localStorage.getItem("user_id") || "",
      "x-access-token": localStorage.getItem("access_token") || "",
      "x-refresh-token": localStorage.getItem("refresh_token") || "",
    }),
    []
  );

  // Tier 체크
  const userTier = useMemo(() => {
    const t = localStorage.getItem("user_tier");
    return t ? parseInt(t, 10) : 2; 
  }, []);

  // Builder(2)는 MCP 추가 불가
  const canCreateMCP = userTier <= 1;

  const normalizeTags = (t: any): string[] => {
    if (!t && t !== 0) return [];
    if (Array.isArray(t)) return t.map(String);
    if (typeof t === "string") {
      try {
        const parsed = JSON.parse(t);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch {
        const parts = t.split(",").map((s) => s.trim()).filter(Boolean);
        return parts;
      }
      return t ? [t] : [];
    }
    return [String(t)];
  };

  const fetchModules = () => {
    setLoadingModules(true);
    axios
      .get(`${API_BASE}mcp-list`, { headers: authHeaders })
      .then((res) => {
        const body = res.data;
        if (body.success) {
          const rows: ModuleItem[] = body.data.modules || [];
          setModules(
            rows.map((m) => ({
              ...m,
              tags: normalizeTags(m.tags),
              auto_approve: typeof m.auto_approve === "boolean" ? m.auto_approve : false,
            }))
          );
          setErrorMsg(null);
        } else {
          setErrorMsg(body.message || body.error || "MCP 목록 조회 실패");
        }
      })
      .catch((err) => {
        console.error(err);
        setErrorMsg("MCP 목록을 불러오는 중 오류가 발생했습니다.");
      })
      .finally(() => setLoadingModules(false));
  };

  const fetchMyAccessStatus = async () => {
    setLoadingAccess(true);
    try {
      const [reqRes, apprRes] = await Promise.all([
        axios.get(`${API_BASE}mcp/me/access`, {
          headers: authHeaders,
          params: { status: "requested" },
        }),
        axios.get(`${API_BASE}mcp/me/access`, {
          headers: authHeaders,
          params: { status: "approved" },
        }),
      ]);

      if (reqRes.data?.success) {
        const list: MyAccessItem[] = reqRes.data.data || [];
        setRequestedSet(new Set(list.map((x) => x.module_key)));
      } else {
        setRequestedSet(new Set());
      }

      if (apprRes.data?.success) {
        const list: MyAccessItem[] = apprRes.data.data || [];
        setApprovedSet(new Set(list.map((x) => x.module_key)));
      } else {
        setApprovedSet(new Set());
      }
    } catch (e) {
      console.warn("Failed to load my access status");
      setRequestedSet(new Set());
      setApprovedSet(new Set());
    } finally {
      setLoadingAccess(false);
    }
  };

  useEffect(() => {
    fetchModules();
    fetchMyAccessStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ 검색 필터링
  const filteredModules = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return modules;
    return modules.filter((m) => {
      const tagText = normalizeTags(m.tags).join(" ");
      const hay = `${m.module_key} ${m.description} ${m.endpoint_prefix} ${tagText}`.toLowerCase();
      return hay.includes(q);
    });
  }, [modules, query]);

  // ✅ [수정됨] 그룹핑 로직 (Global / Org Official / Teams 분리)
  const groupedModules = useMemo(() => {
    const global: ModuleItem[] = [];
    const orgOfficial: ModuleItem[] = [];
    const teams: Record<string, ModuleItem[]> = {}; 

    filteredModules.forEach((mod) => {
      // 1) 전체 공용
      if (mod.org_id === '#GLOBAL#') {
        global.push(mod);
      } 
      // 2) 조직 공식 (Tier 0)
      else if (mod.user_tier === 0) {
        orgOfficial.push(mod);
      } 
      // 3) 팀/개인 전용 (Tier 1 이상)
      else {
        // 작성자 ID (예: asset)를 키로 그룹핑
        const creator = mod.user_id || "Unknown";
        if (!teams[creator]) {
          teams[creator] = [];
        }
        teams[creator].push(mod);
      }
    });

    return { global, orgOfficial, teams };
  }, [filteredModules]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setModuleKey("");
    setModuleKeyError(null);
    setDescription("");
    setTags([]);
    setTagInput("");
    setTagError(null);
    setAutoApprove(false);
    setCreating(false);
    setOpen(false);
  };

  const addTag = (raw: string) => {
    setTagError(null);
    const val = raw.trim();
    if (!val) return;
    if (tags.length >= 10) {
      setTagError("최대 10개까지 가능합니다.");
      return;
    }
    const normalized = val.replace(/\s+/g, "-");
    if (tags.includes(normalized)) {
      setTagError("중복 태그입니다.");
      return;
    }
    setTags((prev) => [...prev, normalized]);
  };

  const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
      e.preventDefault();
      if (tagInput.trim()) {
        addTag(tagInput);
        setTagInput("");
      }
    }
  };

  const removeTag = (idx: number) => {
    setTags((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleAddModule = () => {
    setModuleKeyError(null);
    const mk = moduleKey.trim();
    if (!mk) return setModuleKeyError("모듈 키를 입력하세요.");
    
    const exists = modules.some((m) => (m.module_key || "").toLowerCase() === mk.toLowerCase());
    if (exists) return setModuleKeyError(`모듈키 '${mk}'는 이미 존재합니다.`);

    const payload = {
      module_key: mk,
      description: description || "",
      tags: tags,
      auto_approve: autoApprove,
    };

    setCreating(true);
    axios
      .post(`${API_BASE}mcp-modules`, payload, { headers: authHeaders })
      .then((res) => {
        if (res.data.success) {
          fetchModules();
          handleClose();
        } else {
          setErrorMsg(res.data.message || "모듈 추가 실패");
        }
      })
      .catch((err) => {
        setErrorMsg("모듈 추가 중 오류 발생");
      })
      .finally(() => setCreating(false));
  };

  const openModule = (module_key: string) => navigate(`/mcp/${module_key}`);

  const LoadingBanner = (props: { text: string }) => (
    <Paper variant="outlined" sx={{ mb: 2 }}>
      <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
        <CircularProgress size={20} />
        <Typography>{props.text}</Typography>
      </Box>
      <LinearProgress />
    </Paper>
  );

  const AccessStatusChip = ({ mk }: { mk: string }) => {
    if (approvedSet.has(mk)) {
      return <Chip size="small" color="success" label="승인됨" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
    }
    if (requestedSet.has(mk)) {
      return <Chip size="small" color="warning" label="요청중" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
    }
    return <Chip size="small" variant="outlined" label="미설치" clickable onClick={(e)=>{e.stopPropagation(); openModule(mk)}} />;
  };

  const anyLoading = loadingModules || loadingAccess;

  // ✅ 카드 렌더링 헬퍼 컴포넌트
  const ModuleCard = ({ mod }: { mod: ModuleItem }) => {
    const tagList = normalizeTags(mod.tags);
    const hasFunctionsCount = typeof mod.endpoint_count === "number";

    return (
      <Card
        sx={{
          bgcolor: "#1e1e1e",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          cursor: "pointer",
          transition: "all 0.2s",
          "&:hover": { 
            transform: "translateY(-4px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
            outline: "1px solid rgba(255,255,255,0.2)" 
          },
        }}
        onClick={() => openModule(mod.module_key)}
      >
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8, color: "grey.500" }}
          onClick={(e) => { e.stopPropagation(); openModule(mod.module_key); }}
        >
          <LaunchIcon fontSize="small" />
        </IconButton>

        <CardContent sx={{ flexGrow: 1, p: 3 }}>
          <Box mb={2}>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <Typography variant="h6" color="#fff" fontWeight={700}>
                {mod.module_key}
              </Typography>
              <AccessStatusChip mk={mod.module_key} />
            </Stack>
            
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
              {mod.auto_approve && (
                <Chip size="small" label="자동승인" color="primary" variant="outlined" sx={{ height: 20, fontSize: "0.7rem" }} />
              )}
              {Array.isArray(mod.functions) && (
                <Chip size="small" label={`${mod.functions.length} funcs`} sx={{ height: 20, fontSize: "0.7rem", bgcolor: "#333" }} />
              )}
              {hasFunctionsCount && !Array.isArray(mod.functions) && (
                <Chip size="small" label={`${mod.endpoint_count} funcs`} sx={{ height: 20, fontSize: "0.7rem", bgcolor: "#333" }} />
              )}
            </Stack>
          </Box>

          <Typography variant="body2" color="grey.400" sx={{ mb: 2, minHeight: 40, lineHeight: 1.5 }}>
            {mod.description || "설명이 없습니다."}
          </Typography>

          <Divider sx={{ my: 1.5, borderColor: "#333" }} />

          <Box sx={{ minHeight: 24 }}>
            {tagList.length > 0 ? (
              <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                {tagList.slice(0, 5).map((t, i) => (
                  <Chip 
                    key={i} 
                    size="small" 
                    label={`#${t}`} 
                    sx={{ bgcolor: "rgba(255,255,255,0.05)", color: "#aaa", fontSize: "0.7rem", height: 22 }} 
                  />
                ))}
                {tagList.length > 5 && (
                  <Typography variant="caption" color="grey.600" sx={{ pt: 0.5 }}>+{tagList.length - 5}</Typography>
                )}
              </Stack>
            ) : (
              <Typography variant="caption" color="grey.700">No Tags</Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box>
      {/* 상단 로딩 */}
      {anyLoading && <LoadingBanner text="데이터를 불러오는 중..." />}

      {/* 헤더 + 검색 + 추가 버튼 */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Box>
          <Typography variant="h6" fontWeight="bold">MCP Tool</Typography>
          <Typography variant="body2" color="text.secondary">
            AI Agent가 활용할 수 있는 다양한 도구(Tool)들을 탐색하고 설치하세요.
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            size="small"
            placeholder="검색 (키워드, 태그)"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>),
            }}
            sx={{ width: 250 }}
          />
          {canCreateMCP && (
            <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpen}>
              추가
            </Button>
          )}
        </Box>
      </Box>

      {/* ✅ 섹션 1: 전체 공용 (#GLOBAL#) */}
      {groupedModules.global.length > 0 && (
        <Box mb={4}>
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <PublicIcon color="secondary" />
            <Typography variant="h6" fontWeight="bold" color="#ce93d8">
              전체 공용 (Global Tools)
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            {groupedModules.global.map((mod) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={mod.module_key}>
                <ModuleCard mod={mod} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* ✅ 섹션 2: 조직 공용 (Org Official - Tier 0) */}
      {groupedModules.orgOfficial.length > 0 && (
        <Box mb={4}>
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <BusinessIcon color="primary" />
            <Typography variant="h6" fontWeight="bold" color="#90caf9">
              {groupedModules.orgOfficial[0].org_id} 조직 공용
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            {groupedModules.orgOfficial.map((mod) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={mod.module_key}>
                <ModuleCard mod={mod} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* ✅ 섹션 3: 팀/개인 전용 (Teams - Tier 1+) */}
      {Object.entries(groupedModules.teams).map(([teamId, mods]) => (
        <Box mb={4} key={teamId}>
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <FaceIcon sx={{ color: "#aaa" }} />
            <Typography variant="h6" fontWeight="bold" color="#eee">
              {teamId} 팀 전용
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            {mods.map((mod) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={mod.module_key}>
                <ModuleCard mod={mod} />
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}

      {/* 결과 없음 표시 */}
      {!loadingModules && filteredModules.length === 0 && (
        <Box sx={{ color: "#666", textAlign: "center", py: 8 }}>
          검색 결과가 없습니다.
        </Box>
      )}

      {/* 다이얼로그 (생성용) */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "#fff" } }}>
        <DialogTitle sx={{ borderBottom: "1px solid #333" }}>새 MCP 도구 추가</DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <TextField
            autoFocus
            label="모듈 키 (ID)"
            value={moduleKey}
            onChange={(e) => { setModuleKey(e.target.value); setModuleKeyError(null); }}
            fullWidth
            margin="normal"
            placeholder="예) weather-tool"
            helperText={moduleKeyError}
            error={!!moduleKeyError}
            InputLabelProps={{ style: { color: "#aaa" } }}
            InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
          />
          <TextField
            label="설명"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={2}
            margin="normal"
            InputLabelProps={{ style: { color: "#aaa" } }}
            InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
          />
          <FormControlLabel
            control={<Switch checked={autoApprove} onChange={(e) => setAutoApprove(e.target.checked)} />}
            label={<Typography color="#ccc">자동 승인</Typography>}
            sx={{ mt: 1 }}
          />
          <Divider sx={{ my: 2, borderColor: "#333" }} />
          <Typography variant="caption" color="grey.500" sx={{ mb: 1, display: "block" }}>
            태그 (Enter로 추가)
          </Typography>
          <TextField
            size="small"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={handleTagKeyDown}
            fullWidth
            InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
          />
          <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
            {tags.map((t, i) => (
              <Chip key={i} label={t} onDelete={() => removeTag(i)} size="small" sx={{ bgcolor: "#333", color: "#fff" }} />
            ))}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: "1px solid #333" }}>
          <Button onClick={handleClose} sx={{ color: "#aaa" }}>취소</Button>
          <Button variant="contained" onClick={handleAddModule} disabled={!moduleKey.trim() || creating}>
            {creating ? "추가 중..." : "추가"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}